import localAdminApi from '../utils/localAdminApi';

export const supportService = {
  // Get all support tickets with filtering and sorting
  getAllTickets: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.status) params.append('status', filters.status);
    if (filters.assigned_to) params.append('assigned_to', filters.assigned_to);
    if (filters.show_archived) params.append('show_archived', filters.show_archived);
    if (filters.sort_by) params.append('sort_by', filters.sort_by);
    
    const queryString = params.toString();
    const url = queryString ? `/api/admin/support/tickets?${queryString}` : '/api/admin/support/tickets';
    
    const response = await localAdminApi.get(url);
    return response.data;
  },

  // Get single ticket by ID
  getTicketById: async (ticketId) => {
    const response = await localAdminApi.get(`/api/admin/support/tickets/${ticketId}`);
    return response.data;
  },

  // Update ticket (status, assignment, archive)
  updateTicket: async (ticketId, updateData) => {
    const response = await localAdminApi.put(`/api/admin/support/tickets/${ticketId}`, updateData);
    return response.data;
  },

  // Archive ticket
  archiveTicket: async (ticketId) => {
    const response = await localAdminApi.put(`/api/admin/support/tickets/${ticketId}/archive`);
    return response.data;
  },

  // Reactivate ticket
  reactivateTicket: async (ticketId) => {
    const response = await localAdminApi.put(`/api/admin/support/tickets/${ticketId}/reactivate`);
    return response.data;
  },

  // Delete support ticket with admin password
  deleteTicket: async (ticketId, adminPassword) => {
    const response = await localAdminApi.delete(`/api/admin/support/tickets/${ticketId}`, {
      data: { password: adminPassword }
    });
    return response.data;
  },

  // Add a reply message to ticket
  addTicketMessage: async (ticketId, messageData) => {
    const response = await localAdminApi.post(`/api/admin/support/tickets/${ticketId}/messages`, messageData);
    return response.data;
  },

  // Get all messages for a ticket
  getTicketMessages: async (ticketId, includeInternal = true) => {
    const params = includeInternal ? '?include_internal=true' : '?include_internal=false';
    const response = await localAdminApi.get(`/api/admin/support/tickets/${ticketId}/messages${params}`);
    return response.data;
  },

  // Add internal note
  addInternalNote: async (ticketId, note) => {
    const response = await localAdminApi.post(`/api/admin/support/tickets/${ticketId}/internal-note`, { note });
    return response.data;
  },

  // Get support statistics
  getSupportStats: async () => {
    const response = await localAdminApi.get('/api/admin/support/stats');
    return response.data;
  },

  // Create new ticket (for testing purposes)
  createTicket: async (ticketData) => {
    const response = await localAdminApi.post('/api/support/tickets', ticketData);
    return response.data;
  },

  // Clear test data (admin function)
  clearTestData: async () => {
    const response = await localAdminApi.delete('/api/admin/support/clear-test-tickets');
    return response.data;
  },

  // Clear test messages (admin function)
  clearTestMessages: async () => {
    const response = await localAdminApi.delete('/api/admin/support/messages/clear-test-messages');
    return response.data;
  }
};